export default "__VITE_ASSET__C8V3Kbdv__"